<template>
  <fn-pricing
    :badges="badges"
    :hidden-badges="hiddenBadges"
    :deal-badge-position-top="dealBadgePositionTop"
    :large="large"
    :small="small"
    :product-variant="productVariant"
    :display-tax-info="displayTaxInfo"
    :price="pricing.current?.formattedValue"
    :recommended-price="pricing.recommendedRetailPrice?.formattedValue"
    :former="pricing.former?.formattedValue"
    :former-price-savings="pricing.savings"
    :per-unit="pricing.perUnit?.formattedValue"
    :tax-info="taxVisible"
    :stock-level-status="stockLevelStatus"
    :friends-price="pricing.friendsPrice?.formattedValue"
    :friends-price-per-unit="pricing.friendsPricePerUnit?.formattedValue"
    @change-tab="(tab) => $emit('changeTab', tab)"
  />
</template>

<script>
export default defineComponent({
  props: {
    pricing: {
      type: Object,
      required: true,
    },
    displayTaxInfo: {
      type: Boolean,
      default: false,
    },
    taxVisible: {
      type: Boolean,
    },
    stockLevelStatus: {
      type: String,
      default: null,
    },
    large: {
      type: Boolean,
    },
    small: {
      type: Boolean,
    },
    productVariant: {
      type: Boolean,
    },
    badges: {
      type: Array,
      default: () => [],
    },
    hiddenBadges: {
      type: Array,
      default: () => [],
    },
    dealBadgePositionTop: {
      type: Boolean,
    },
  },
  emits: ['changeTab'],
});
</script>
